import { render, staticRenderFns } from "./mineExchange.vue?vue&type=template&id=72ec49aa&scoped=true"
import script from "./mineExchange.vue?vue&type=script&lang=js"
export * from "./mineExchange.vue?vue&type=script&lang=js"
import style0 from "./mineExchange.vue?vue&type=style&index=0&id=72ec49aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec49aa",
  null
  
)

export default component.exports